/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="statistics"
          transform="translate(-28.000000, -737.000000)"
          stroke="currentColor"
        >
          <g
            id="iPhone-X/Bars/Tab-Bar/5-Items"
            transform="translate(0.000000, 722.000000)"
          >
            <g id="Item-1" transform="translate(14.000000, 8.000000)">
              <g id="Active-Icon">
                <g id="Group-200" transform="translate(14.000000, 7.000000)">
                  <path
                    d="M9.3085,0.95825 L0.416833333,9.83075 L2.08683333,9.83075 L2.08683333,19.83075 L7.09766667,19.83075 L7.09766667,12.33075 L12.9435,12.33075 L12.9435,19.83075 L17.9543333,19.83075 L17.9543333,9.83075 L19.6251667,9.83075 L10.7335,0.95825 C10.5443333,0.769916667 10.2885,0.664083333 10.0218333,0.664083333 L10.0201667,0.664083333 C9.7535,0.664083333 9.49683333,0.769916667 9.3085,0.95825 L9.3085,0.95825 Z"
                    id="Stroke-392"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
